const purchaseHistoryNL = {
    "view": {
        "table": {
            "title": "Uw aankoopgeschiedenis",
            "column": {
                "amount": "Bedrag",
                "description": "Beschrijving",
                "credits_balance": "Creditsaldo",
                "tokens_balance": "Tokensaldo",
                "date_of_purchase": "Aankoopdatum",
                "receipt": "Ontvangstbewijs"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "view": "Bekijken",
                "export_csv": "Exporteer CSV"
            }
        }
    }
};

export default purchaseHistoryNL;